export const LOGIN_CONTEXT_PARAM = 'c';
